export default "__VITE_ASSET__88cf8dab__"